import React from "react";
import styled from "styled-components";

export const TimeOpenColumn = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    text-transform: none;
    font-size: 11px;
    font-weight: normal;
`;

export const TimeOpenValue = styled(TimeOpenColumn)`
    font-size: 12px;
    align-items: flex-end;
`;